// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"UserSearchInput_inputContainer__z9ljV","input":"UserSearchInput_input__69G4W"};